import React from 'react';
import { SCREEN_PADDING } from '@/styles';
import { ScrollView, StyleSheet, View } from 'react-native';

const MAX_CONTENT_WIDTH = 1220;

interface Props {
  children: React.ReactNode;
}

export const MaxWidthLargeContent: React.FC<Props> = ({ children }) => {
  return (
    <ScrollView contentContainerStyle={styles.base}>
      <View style={styles.content}>{children}</View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    paddingHorizontal: SCREEN_PADDING,
  },
  content: {
    flex: 1,
    maxWidth: MAX_CONTENT_WIDTH,
    width: '100%',
  },
});
